<template>
  <div>
    <SellHeader :img_header="header_image" header="แก้ไขคำสั่งซื้อ" :link_back="link_back"/>
    <Order_partner_edit/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/boxes_sell.png";
import Order_partner_edit from "@/components/admin/sell/Order_partner_edit";
export default {
  name: "OrderPartnerEdit",
  components: {
    Order_partner_edit,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage,
      link_back: 'sell/orderpartnerdetail/' + this.$route.params.id
    }
  }
}
</script>

<style scoped>

</style>
